import filters from './filter'
import directives from './directive'
import $field from './service/$locale'

export default {
  methods: {
    $field
  },
  filters: {
    ...filters
  },
  directives: {
    ...directives
  }
}


// WEBPACK FOOTER //
// ./src/modules/index.js